import { of, TimeoutError, EMPTY } from 'rxjs';
import { mergeMap, withLatestFrom, map, catchError, takeUntil, mapTo } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import * as SHOP from '../constants/Shop';
import * as ShopActions from '../actions/ShopActions';
import * as ShopService from '../service/ShopService';
import customData from '../customData.json';
import * as CommonActions from '../actions/CommonActions';
import { memberIdSelector } from '../utils/BookingUtils';

/* Get Shop Info */
const getShopInfoEpic = (action$, state$) => action$.pipe(
  ofType(SHOP.GET_SHOP_INFO),
  withLatestFrom(state$),
  mergeMap(([action, state]) => {
    const { locale, sid } = state.common;
    const memberid = memberIdSelector(state)

    const params = {
      shopId: sid,
      lang: locale,
      memberid
    }

    return ShopService.getShopInfo(params).pipe(
      map((res) => {
        if (!res || res === null) {
          return ShopActions.getShopInfoRejectedAction('Cannot find the shop');
        }
        // Remove user key, only remain shop key
        // const deleteKeys = ['id', 'qrCode', 'name', 'gradeName', 'expiryDate', 'points', 'tel'];
        // deleteKeys.forEach((key) =>  {
        //   if (res.hasOwnProperty(key)){
        //     delete res[key];
        //   }
        // });

        return ShopActions.getShopInfoFulfilledAction(res);
      }),
      catchError((error) => of(ShopActions.getShopInfoRejectedAction('cannot find shop address'))),
      takeUntil(action$.pipe(ofType(SHOP.GET_SHOP_INFO_CANCELLED))),
    );
  }),
);

/* Get Shop Address */
const getShopAddressEpic = (action$, state$) => action$.pipe(
  ofType(SHOP.GET_SHOP_ADDRESS),
  withLatestFrom(state$),
  mergeMap(([action, state]) => {
    let { params } = action.payload.data;
    const { locale } = state.common;
    const { sid } = state.common;

    if (!sid) return of(ShopActions.getShopAddressRejectedAction('cannot find shop address'));

    if (!params) {
      params = {
        shop_id: sid,
        lang: locale,
      }
    } else {
      params = {
        latitude: params.latitude !== undefined ? params.latitude : '',
        longitude: params.longitude !== undefined ? params.longitude : '',
        shop_id: sid,
        lang: locale,
      }
    }

    return ShopService.getShopAddress(params).pipe(
      map((res) => {
        if (!res || res === null) {
          return ShopActions.getShopAddressRejectedAction('Cannot find shop address');
        }
        return ShopActions.getShopAddressFulfilledAction(res);
      }),
      catchError((error) => of(ShopActions.getShopAddressRejectedAction('cannot find shop address'))),
      takeUntil(action$.pipe(ofType(SHOP.GET_SHOP_ADDRESS_CANCELLED))),
    );
  }),
);

/* Get Shop Address */
const getShopDescriptionEpic = (action$, state$) => action$.pipe(
  ofType(SHOP.GET_SHOP_DESCRIPTION),
  withLatestFrom(state$),
  mergeMap(([action, state]) => {
    const { locale } = state.common;
    const { sid } = state.common;

    const params = {
      shopId: sid,
      lang: locale,
    }

    if (!sid) return of(ShopActions.getShopDescriptionRejectedAction('cannot find shop address'));

    return ShopService.getShopDescription(params).pipe(
      map((res) => {
        if (!res || res === null) {
          return ShopActions.getShopDescriptionRejectedAction('Cannot find shop address');
        }
        return ShopActions.getShopDescriptionFulfilledAction(res);
      }),
      catchError((error) => of(ShopActions.getShopDescriptionRejectedAction('cannot find shop address'))),
      takeUntil(action$.pipe(ofType(SHOP.GET_SHOP_DESCRIPTION_CANCELLED))),
    );
  }),
);

const updateLanguageEpic = (action$, state$) => action$.pipe(
  ofType(SHOP.GET_SHOP_INFO_FULFILLED),
  withLatestFrom(state$),
  mergeMap(([action, state]) => {
    if (!state.common.locale && action.payload.data.defaultLanguage) {
      return of(CommonActions.setLang(action.payload.data.defaultLanguage));
    }
    return EMPTY;
  })
)

export default [
  getShopInfoEpic,
  getShopAddressEpic,
  getShopDescriptionEpic,
  updateLanguageEpic,
];
